var map = {
	"./chameleon-theme-az/lib/styleguide/tokens.android.json": "d5QW",
	"./chameleon-theme-beltel/lib/styleguide/tokens.android.json": "u53d",
	"./chameleon-theme-co/lib/styleguide/tokens.android.json": "ToQE",
	"./chameleon-theme-dl/lib/styleguide/tokens.android.json": "LRMJ",
	"./chameleon-theme-ds/lib/styleguide/tokens.android.json": "8r87",
	"./chameleon-theme-ge/lib/styleguide/tokens.android.json": "lLMI",
	"./chameleon-theme-gva/lib/styleguide/tokens.android.json": "apJB",
	"./chameleon-theme-hbvl/lib/styleguide/tokens.android.json": "AIew",
	"./chameleon-theme-hd/lib/styleguide/tokens.android.json": "xP7Y",
	"./chameleon-theme-hub/lib/styleguide/tokens.android.json": "C4ou",
	"./chameleon-theme-indo/lib/styleguide/tokens.android.json": "/pIV",
	"./chameleon-theme-ld/lib/styleguide/tokens.android.json": "qDOH",
	"./chameleon-theme-lt/lib/styleguide/tokens.android.json": "C4IZ",
	"./chameleon-theme-lw/lib/styleguide/tokens.android.json": "oDOA",
	"./chameleon-theme-mh/lib/styleguide/tokens.android.json": "5MhN",
	"./chameleon-theme-nb-legacy/lib/styleguide/tokens.android.json": "95eu",
	"./chameleon-theme-nb/lib/styleguide/tokens.android.json": "8i7S",
	"./chameleon-theme-nhd/lib/styleguide/tokens.android.json": "B+vY",
	"./chameleon-theme-sw/lib/styleguide/tokens.android.json": "8RR1",
	"./chameleon-theme-tc/lib/styleguide/tokens.android.json": "lJsH",
	"./chameleon-theme-tel/lib/styleguide/tokens.android.json": "MAqC",
	"./chameleon-theme-vl/lib/styleguide/tokens.android.json": "Y7ZG",
	"./chameleon-theme-wl/lib/styleguide/tokens.android.json": "daB6",
	"./chameleon-theme-yc/lib/styleguide/tokens.android.json": "HgQj"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FS9q";